export default __webpack_public_path__ + "media/titles/title_2_locale_nl-7fe8b01a.png";